import {Component, EventEmitter, Inject, Input, OnInit, Optional, Output, SkipSelf} from '@angular/core';
import {CheckboxInputComponent} from '@blocks/input/checkbox-input/checkbox-input.component';
import {RadioInputComponent} from '@blocks/input/radio-input/radio-input.component';
import {BlockType, SelectOption} from '@paperlessio/sdk/api/models';
import {BLOCKS_CONFIG, BlocksConfig} from '@blocks/blocks.config';
import {ContentLocale} from '@paperlessio/sdk/api/util';

@Component({
  selector: 'pl-option-buttons',
  templateUrl: './option-buttons.component.html',
  styleUrls: ['./option-buttons.component.scss']
})
export class OptionButtonsComponent implements OnInit {
  constructor(@Inject(BLOCKS_CONFIG) public blocksConfig: BlocksConfig,
              @SkipSelf() @Optional() public checkboxParent?: CheckboxInputComponent,
              @SkipSelf() @Optional() public radioParent?: RadioInputComponent) { }

  @Input() options: SelectOption[] | undefined;
  @Input() currentContentLocale: ContentLocale;
  @Input() originalContentLocale: ContentLocale;
  @Input() data: number [] | undefined;
  @Input() defaults: number[] | undefined;
  @Input() name = '';
  @Input() disabled = false;
  @Input() readonly = false;

  @Output() check = new EventEmitter<CheckData>();

  blockType: BlockType | null = null;
  inputType = '';

  ngOnInit(): void {
    this.blockType = !!this.checkboxParent ? BlockType.CheckboxInput : !!this.radioParent ? BlockType.RadioInput : null;
    this.inputType = !!this.checkboxParent ? 'checkbox' : !!this.radioParent ? 'radio' : '';
  }

  isChecked(option: SelectOption): boolean {
    if (this.data?.length > 0) {
      return !!this.data?.includes(option.id);
    } else {
      return this.defaults?.includes(option.id);
    }
  }

  fireCheck(checked: boolean, id: number) {
    if (checked != null || id != null) {
      this.check.emit({checked, id});
    }
  }
}

export interface CheckData {
  checked: boolean;
  id: number;
}
